import { Component, Input, OnInit } from '@angular/core';

//Part of the PDF module, make sure to import the PDF module in the parent module
@Component({
  selector: 'monorepo-show-pdf',
  templateUrl: './show-pdf.component.html',
  styleUrls: ['./show-pdf.component.scss'],
})
export class ShowPdfComponent implements OnInit {
  //src is the url for the PDF
  @Input() src!: string;
  constructor() {}

  ngOnInit(): void {}
}
